<ng-container>
  <td>
    @if (isArticle) {
      <span class="fetchcount">
        {{ fetch.ordering }}
      </span>
    }
    @if (isArticle && showConfirmedLabel) {
      <span class="label label-primary">
        BESTÄTIGT
      </span>
    }
    @if (showClearedLabel) {
      <span class="label label-success">
        ABGERECHNET
      </span>
    }
    @if (showConcludedLabel) {
      <span class="label label-default" title="ABGESCHLOSSEN / NICHT ABGERECHNET">
        ABGESCHLOSSEN
      </span>
    }
  </td>

  <td>
    @if (showPositionInputs) {
      <div class="col-sm-12">
        <div class="row">
          <input class="w-full"
            type="text"
            [name]="'position_label_' + position.id"
            [ngModel]="position.label"
            (ngModelChange)="position.label = $event; updateElement(fetchIndex, positionIndex, fetch, position)">
        </div>
        <div class="row">
          @if (isArticle) {
            <textarea class="position w-full text-px-11"
              id="desextension"
              maxlength="158"
              [name]="'position_desextension_' + position.id"
              [ngModel]="position.desextension"
              (ngModelChange)="position.desextension = $event; updateElement(fetchIndex, positionIndex, fetch, position)"
              >
            </textarea>
          }
        </div>
      </div>
    } @else {
      <div class="col-sm-12">
        <div class="row">
          <span>
            {{ position.label }}
          </span>
        </div>
        <div class="row">
          @if (isArticle) {
            <span>
              <br/>
              {{ position.desextension }}
            </span>
          }
        </div>
      </div>
    }
  </td>

  <td class="align-right">
    @if (showPositionInputs) {
      <input type="text"
        class="align-right w-full"
        [name]="'position_quantity_' + position.id"
        [ngModel]="position.quanity"
        (ngModelChange)="position.quanity = $event; updateElement(fetchIndex, positionIndex, fetch, position)">
    } @else {
      <span>{{ position.quanity }}</span>
    }
  </td>

  @switch (position.typ) {
    @case ('extracost_percentual') {
      <td class="align-right">
        @if (editable) {
          <div class="inline-block w-8/12">
            <input
              (ngModelChange)="position.percentual = $event; updateElement(fetchIndex, positionIndex, fetch, position)"
              [name]="'position_percentual_' + position.id"
              [ngClass]="{'red_alert': position['percentual_error']}"
              [ngModel]="position.percentual"
              class="align-right inline-block w-32"
              type="text">
          </div>
          <div class="inline-block w-2/12">%</div>
          <div class="inline-block w-2/12">
            <button type="button" class="btn btn-link text-black!" (click)="reloadExtraCostPercent(position)">
              <i class="fa fa-refresh text-px-15!"></i>
            </button>
          </div>
        } @else {
          <div class="inline-block w-10/12">
            {{ position.percentual }}
          </div>
          <div class="inline-block w-2/12">%</div>
        }
      </td>
    }
    @default {
      <td>
        @if (editable) {
          <ng-container>
            <div class="inline-block w-10/12 p-0 align-right">
              <input type="text"
                class="align-right w-full -mr-2"
                [name]="'position_price_' + position.id"
                [ngClass]="{'red_alert': position['price_error']}"
                [ngModel]="position.price"
                (ngModelChange)="priceUpdate($event, fetchIndex, positionIndex, fetch, position)">
            </div>
            <div class="inline-block w-2/12 p-0 pt-2">&nbsp;€</div>
          </ng-container>
        } @else {
          <ng-container>
            <div class="inline-block w-10/12 p-0 align-right" [ngClass]="{gray_font: !!priceIncreaseFlexString}">
              {{ position.price }}
            </div>
            <div class="inline-block w-2/12 p-0" [ngClass]="{gray_font: !!priceIncreaseFlexString}">&nbsp;€</div>
          </ng-container>
        }
        @if (isArticle && !!priceIncreaseFlexString) {
          <ng-container>
            <div class="inline-block w-10/12 p-0 align-right" [ngbTooltip]="priceIncreaseFlexString">
              {{ priceWithIncrease|money:3}}
            </div>
            <div class="inline-block w-2/12 p-0">&nbsp;€</div>
          </ng-container>
        }
      </td>
    }
  }

  <td class="align-right">
    {{ priceTotal|money:2 }}&nbsp;€
  </td>

  <td>
    @if (isArticle) {
      @if (showPositionInputs) {
        <input (ngModelChange)="fetch.order_nr = $event; updateElement(fetchIndex, positionIndex, fetch, position)"
               [name]="'fetch_order_nr_' + position.id"
               [ngModel]="fetch.order_nr"
               type="text">
      } @else {
        <span>
          {{ fetch.order_nr }}
        </span>
      }
    }
  </td>

  <td>
    @if (isArticle) {
      @if (!showPositionInputs) {
        <div class="inline-block">
          {{ fetch.delivery }}
        </div>
      }
      @if (showPositionInputs && isAsian) {
        <ev-datepicker placeholder="__ . __ . _____"
                       [future]="true"
                       [name]="'fetch_delivery_' + position.id"
                       [ngModel]="fetch.delivery"
                       [writeBack]="false"
                       (ngModelChange)="fetch.delivery = $event; updateElement(fetchIndex, positionIndex, fetch, position)"
        >
        </ev-datepicker>
      }

      @if (use && isGerman) {
        <material-planning-date-check [article]="article"
          [amount]="position.quanity"
          [date]="fetch.delivery"
          [preload]="displayDeliveryDateCheck"
          (dateChanged)="fetch.delivery = $event; updateElement(fetchIndex, positionIndex, fetch, position)"
          >
        </material-planning-date-check>
      }

      @if (use) {
        <div class="form-control border-0! bg-transparent! shadow-none!">
          <input
            (ngModelChange)="fetch.earliest_delivery = $event === true; updateElement(fetchIndex, positionIndex, fetch, position)"
            [id]="'fetch_earliest_delivery_' + position.id" [name]="'fetch_earliest_delivery_' + position.id"
            [ngModel]="fetch.earliest_delivery"
            class="float-left"
            type="checkbox">
          <label [for]="'fetch_earliest_delivery_' + position.id" class="text-px-10">
            Frühestmöglicher Liefertermin
          </label>
        </div>
      } @else if (fetch.earliest_delivery) {
        <div class="inline-block">
          <i class="fa fa-check fa-2x green"></i>&nbsp;Frühestmöglicher Liefertermin
        </div>
      }
    }
  </td>

  <td>
    @if (isArticle) {
      @if (use) {
        <input
          (ngModelChange)="fetch.is_complaint = $event === true; updateElement(fetchIndex, positionIndex, fetch, position)"
          [name]="'fetch_is_complaint_' + position.id"
          [ngModel]="fetch.is_complaint"
          type="checkbox">
      } @else if (fetch.is_complaint) {
        <div class="inline-block">
          <span class="green"><i class="fa fa-check fa-2x"></i>&nbsp;Ja</span>
        </div>
      }
    }
  </td>

  <td>
    @if (deletable) {
      <button (click)="serviceDropFetch(fetchIndex, positionIndex, fetch, position)"
        class="btn btn-link"
        type="button">
        <i class="fa fa-trash-o"></i>
      </button>
    }
  </td>
  <td>
    @if (isArticle && showSelectionButton) {
      @if (use) {
        <button (click)="dropFetch()"
                class="btn btn-sm btn-danger btn-xs w-32"
                type="button">
          Entfernen
        </button>
      } @else {
        <button (click)="addFetch()"
                class="btn btn-sm btn-success btn-xs w-32"
                type="button">
          Auswählen
        </button>
      }
    }
  </td>
</ng-container>
